import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  bulkInventoryBinService,
  type BulkDisposeAdjustTypeRequest,
  type BulkDisposeAdjustTypeResponse,
} from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';

export const useBulkDisposeAdjustType = () => {
  const queryClient = useQueryClient();

  return useMutation<BulkDisposeAdjustTypeResponse, unknown, BulkDisposeAdjustTypeRequest>({
    mutationFn: (payload) => bulkInventoryBinService.adjustType(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.bulkInventoryBin.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.entities.lists() });
      void queryClient.invalidateQueries({ queryKey: ['transaction-log'] });
      void queryClient.invalidateQueries({ queryKey: ['asset-inventory'] });
    },
  });
};
